import { SupportedSettings } from 'types/aspen/supportedSettings';

export const isSettingSupported = (supportedSettings: Partial<SupportedSettings>, setting: keyof SupportedSettings) =>
  !!supportedSettings?.[setting];
